import { StyleProps } from "@shared/primitive-components"

export const errorText = (props: StyleProps) => ({
  color: props.theme.palette.error,
  marginBottom: props.theme.spacing(4),
})
